import { useState } from "react";
import PropTypes from "prop-types";
import { BbotButton, SettingsCard } from "top-component-library";
import { SaveRow, SettingHint } from "../styles";
import PartyTabDomainRestrictionsDialog from "../PartyTabDomainRestrictionsDialog";

const PartyTabDomainRestrictionsCard = ({ tabsWorkAnywhere, hostnameConfigs, onSave }) => {
  const [dialogVisible, setDialogVisible] = useState(false);

  return (
    <SettingsCard title="Party Tab Domain Restrictions">
      <SettingHint>Manage restrictions on party tab usage across domains.</SettingHint>
      <SaveRow>
        <BbotButton type="primary" onClick={() => setDialogVisible(true)}>
          Edit Party Tab Domain Restrictions
        </BbotButton>
      </SaveRow>
      <PartyTabDomainRestrictionsDialog
        visible={dialogVisible}
        tabsWorkAnywhere={tabsWorkAnywhere}
        hostnameConfigs={hostnameConfigs}
        onClose={() => setDialogVisible(false)}
        onSave={onSave}
      />
    </SettingsCard>
  );
};

PartyTabDomainRestrictionsCard.propTypes = {
  tabsWorkAnywhere: PropTypes.bool.isRequired,
  hostnameConfigs: PropTypes.arrayOf(
    PropTypes.shape({ hostname: PropTypes.string.isRequired, hostnameAliases: PropTypes.string.isRequired })
  ).isRequired,
  onSave: PropTypes.func.isRequired,
};

export default PartyTabDomainRestrictionsCard;
